<template>
  <div class="subscribe-module">
    <div
      v-if="hasHeader"
      class="subscribe-module-header"
    >
      <slot name="header" />
      <slot
        v-if="!mobileMode"
        name="editButton"
      />
    </div>
    <p class="subscribe-info">
      <slot name="info" />
    </p>

    <slot
      v-if="mobileMode"
      name="editButton"
    />
    <slot name="saveButton" />
    <slot name="cancelButton" />
    <slot name="errorMessage" />
  </div>
</template>

<script>
export default {
  name: "StandardModule",
  data () {
    return {
      windowWidth: 0,
      mobileMode: false
    }
  },
  computed: {
    hasHeader () {
      return !!this.$slots.header
    }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth < 768) {
        this.mobileMode = true
      } else {
        this.mobileMode = false
      }
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth
      })
    })
  }
}
</script>

<style lang="scss">
.subscribe-module {
  background: $color-white;
  margin-bottom: 0.5rem;
  padding: 1rem 1.5rem 1.5rem;

  @include media-breakpoint-up(md) {
    border-radius: 0.25rem;
    padding: 1rem 1.5rem 1.5rem;
    box-shadow: $box-shadow-primary;
  }

  &__input {
    display: inline-block;
  }

  &__save-button {
    width: 100%;
    margin: 1.3rem 0;
  }

  .subscribe-info {
    margin: 4px 0;
    max-width: 600px;
  }
}

.subscribe-module-header {
  @include font(text, 3, "black");

  color: $color-secondary-text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 0.025rem;

  &__meta {
    color: $color-secondary-text;
  }
}

.subscribe-module-sub-header {
  margin-bottom: 1rem;
  margin-top: 1.5rem;
  color: $color-secondary-text;
  text-transform: uppercase;

  @include font(text, 2, "black");

  &__info {
    color: $color-grey-dark;
    margin-top: 1.6rem;
    line-height: 2.4rem;
    font-weight: bold;
    font-size: 1.6rem;
  }

  &__edit-button {
    float: right;
    // color: $color-purple;
  }
}

@include media-breakpoint-up(sm) {
  .subscribe-module {
    &__save-button {
      width: inherit;
    }
  }

  .standard-module-cancel-button {
    margin-left: 0.5rem;
  }
}
</style>
